import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent implements OnInit {

  @Input() message?: string;
  @Input() progressMode?: 'determinate' | 'indeterminate' = 'indeterminate';
  @Input() progressValue = 0;
  @Input() showMessage = true;
  itTakesLongTime = false;
  constructor() { }

  ngOnInit() {
    setTimeout(() => {
    }, 30000);
  }

}
